import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getCountFromServer } from 'firebase/firestore';

const Counter = ({ text }) => {
  const [displayCount, setDisplayCount] = useState(0);

  useEffect(() => {
    let animationId = null;

    const initializeCounter = async () => {
      try {
        const coll = collection(db, "user");
        const snapshot = await getCountFromServer(coll);
        const listenerCount = snapshot.data().count;

        const duration = 3000; // 3 seconds in milliseconds
        const start = 0;
        const end = listenerCount;
        const startTime = performance.now();

        const easeOutQuad = (t) => t * (2 - t); // Easing function for smooth animation

        const animateCount = (currentTime) => {
          const elapsedTime = currentTime - startTime;
          const progress = Math.min(elapsedTime / duration, 1); // Clamp to [0, 1]
          const easedProgress = easeOutQuad(progress);
          const currentCount = Math.floor(start + (end - start) * easedProgress);

          setDisplayCount(currentCount);

          if (progress < 1) {
            animationId = requestAnimationFrame(animateCount);
          }
        };

        animationId = requestAnimationFrame(animateCount);
      } catch (error) {
        console.error("Error fetching counter:", error);
      }
    };

    initializeCounter();

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, []);


  return (
    <div>
      <p style={{ fontSize: '16px', color: 'darkgreen', marginTop: '-26px !important' }} className='single-line'>{text}</p>
      <center><p style={{ fontSize: '16px', marginTop: '-2px', color: 'darkgreen' }}>{displayCount || 0}</p></center>
    </div>)
};

export default Counter;